import BottomSheet from '../../../components/BottomSheet'

/**
 * Bottom sheet replacing window.confirm for the "lever scorekortet"
 * commit point. Native confirm() blocks the JS thread and doesn't match
 * the visual system. Per design.md §4 the bottom-sheet radius is 22px;
 * the action button uses the same red-tinted shadow as the action bar
 * so the two feel like siblings.
 *
 * Slide animation + Escape-to-close + backdrop tap + body scroll lock
 * all live in `BottomSheet`. Custom backdrop tint (blurred ink-900/45)
 * carries the heavier "commit" weight this sheet earns vs lighter
 * detail sheets.
 */
const SubmitSheet = ({
  open,
  submitting,
  errorMessage,
  onClose,
  onConfirm,
}: {
  open: boolean
  submitting: boolean
  /** Shown in-sheet when a submit fails (network/timeout) so the player can
   *  retry without losing the confirm context. */
  errorMessage?: string | null
  onClose: () => void
  onConfirm: () => void
}) => (
  <BottomSheet
    open={open}
    onClose={onClose}
    ariaLabel="Lever scorekortet"
    backdropClassName="bg-ink-900/45 backdrop-blur-sm"
    panelClassName="max-w-xl bg-paper"
    showGrabHandle
  >
    <div
      style={{
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)',
      }}
    >
      <div className="px-6 pt-4 pb-2">
        <h2 className="font-display font-extrabold text-xl text-green-900">
          Lever scorekortet?
        </h2>
        <p className="text-sm text-ink-700 mt-2">
          Du leverer scoren for hele flighten. Etter dette kan ingen i flighten
          endre slag — dobbelsjekk at alle 18 hull stemmer.
        </p>
      </div>
      {errorMessage ? (
        <div
          role="alert"
          className="mx-6 mt-3 rounded-lg bg-flag text-paper px-3 py-2 text-sm font-semibold"
        >
          {errorMessage}
        </div>
      ) : null}
      <div className="px-6 pt-4 flex flex-col gap-2">
        <button
          type="button"
          onClick={onConfirm}
          disabled={submitting}
          className="w-full py-3 rounded-xl font-display font-extrabold text-base bg-flag hover:bg-flag-dark text-paper transition-colors disabled:opacity-50"
          style={{ boxShadow: '0 8px 20px -8px rgba(168, 37, 20, 0.6)' }}
        >
          {submitting ? 'Leverer…' : 'Lever scorekortet'}
        </button>
        <button
          type="button"
          onClick={onClose}
          disabled={submitting}
          className="w-full py-3 rounded-xl font-semibold text-base bg-cream-card text-ink-700 hover:bg-ink-100 transition-colors"
        >
          Avbryt
        </button>
      </div>
    </div>
  </BottomSheet>
)

export default SubmitSheet
